<template>
  <div v-if="elements">
    <div
      v-for="element in elements"
      :key="element.id"
      class="d-flex flex-row justify-content-between pb-2 pt-2 machine-item"
    >
      <div class="d-flex flex-row mr-3">
        <div style="color: #757575">{{ element.id }}</div>
        <div class="ml-3" style="color: #212121">{{ element.name }}</div>
      </div>
      <div
        v-if="element.status === $machineStatus.OFF && !element.bootReady"
        class="d-flex flex-row align-items-center status-text-off"
        style="padding: 0.15rem 0.75rem; border-radius: 1rem; height: 1.25rem"
      >
        <i class="el-icon-switch-button" style="font-size: 0.75rem"> </i>
        <span class="ml-2" style="font-size: 0.7rem">{{ $t('machineList.shuttingDown') }}</span>
      </div>
      <div
        v-else
        :class="`d-flex flex-row align-items-center ${
          $machineStatusStyleText[element.status]
        }`"
        style="padding: 0.15rem 0.75rem; border-radius: 1rem; height: 1.25rem"
      >
        <i
          :class="`${$machineStatusIcon[element.status]}`"
          style="font-size: 0.75rem"
        >
        </i>
        <span class="ml-2" style="font-size: 0.7rem">
          {{ $t($machineStatusText[element.status]) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    elements: {
      type: Array,
      default: null,
    },
  },
};
</script>